module.exports = __webpack_public_path__ + "static/livro-12a9959386b5cfbbed0962ea8e37d300.jpg";